import React from 'react';
import { useSelector } from 'react-redux';
import Popup from '../../../../components/ui/popup/Popup';
import HeaderPopup from '../../../../components/ui/popup/headerPopup/HeaderPopup';
import ContentsPopup from '../../../../components/ui/popup/contentPopup/ContentPopup';
import classes from './FinalEndPopup.module.css';

const FinalEndPopup = ({ onClose }) => {
  const { texts } = useSelector((state) => state.translate);

  return (
    <Popup close={onClose} dropClass={classes.finalPopup}>
      <HeaderPopup title={texts?.finalEndPopupTitle} className={classes.header} />
      <ContentsPopup className={classes.popupContent}>
        <div className={classes.content}>
          <p className={classes.text}>{texts?.finalEndPopupText}</p>
        </div>
        <div className={classes.buttonWrapper}>
          <button onClick={onClose} className={classes.buttonPrimary}>
           <p className={classes.buttonPrimaryText}>{texts?.finalEndPopupClose}</p>
          </button>
        </div>
      </ContentsPopup>
    </Popup>
  );
};

export default FinalEndPopup;
